import React from "react";

const AboutUs = () => {
  return (
    <section className="bg-white text-gray-800 py-8 md:py-16 px-4 md:px-12 lg:px-20 mt-20 md:mt-36">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-semibold text-center mb-4">About Us</h2>
        <div className="w-16 h-1 bg-gray-300 mx-auto mb-8"></div>

        <p className="text-center italic text-lg text-cards-border font-medium mb-12">
          At MindTherapyCounselling, we believe that meaningful mental health support begins with empathy, expertise, and accessibility.<br />
          We are here to help you find clarity and growth—through care that is tailored to your unique journey.
        </p>

        <div className="space-y-12">
          <div>
            <h3 className="text-2xl font-semibold mb-3">Who We Are</h3>
            <p className="text-gray-700">
              At MindTherapyCounselling, we are committed to offering high-quality, accessible, and personalised mental health care to people from all walks of life. Our platform was founded in response to the increasing global demand for emotional support and well-being—especially in a world where mental health challenges are more openly acknowledged, yet still often misunderstood or under-treated.
              <br /><br />
              By using the power of technology, we bring therapy directly to you—securely, confidentially, and from the comfort of your own space. Our aim is to remove barriers to support, reduce stigma, and empower individuals to take an active role in their mental well-being.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-3">Our Therapeutic Approaches</h3>
            <p className="text-gray-700 mb-3">
              We believe that no single method works for everyone. That’s why we work with a range of evidence-based therapies, ensuring that your unique needs are met through the right approach—or a tailored combination of approaches.
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>
                <strong>Cognitive Behavioural Therapy (CBT):</strong> A structured, goal-oriented approach effective for anxiety, depression, phobias, and OCD.
              </li>
              <li>
                <strong>Mindfulness-Based Therapy:</strong> Includes MBCT and MBSR to reduce stress and regulate emotions.
              </li>
              <li>
                <strong>Eye Movement Desensitisation and Reprocessing (EMDR):</strong> A powerful method for processing traumatic memories, highly effective for PTSD and unresolved trauma.
              </li>
              <li>
                <strong>Psychodynamic Therapy:</strong> Explores unconscious patterns and past experiences for long-term insight.
              </li>
              <li>
                <strong>Solution-Focused Brief Therapy (SFBT):</strong> Short-term, strengths-based therapy focused on achieving practical goals.
              </li>
              <li>
                <strong>Gottman Method:</strong> Practical strategies to improve communication and resolve conflicts.
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-3">Our Professionals</h3>
            <p className="text-gray-700">
              All our therapists are registered members of at least one professional body, such as BACP, BPC, or HCPC, at MindTherapyCounselling
              <br />
              <ul className="list-disc list-inside mt-2">
                <li>The British Association for Counselling and Psychotherapy (BACP)</li>
                <li>The British Psychoanalytic Council (BPC)</li>
                <li>The Health and Care Professions Council (HCPC)</li>
              </ul>
              <br />
              This ensures that every therapist adheres to rigorous standards of professional training, ethics, and clinical supervision.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-3">Our Values</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Accessibility:</strong> Therapy should be available to everyone, regardless of location or circumstance.</li>
              <li><strong>Compassion:</strong> We meet every client with warmth, respect, and without judgment.</li>
              <li><strong>Ethical Practice:</strong> Confidentiality, trust, and integrity are the foundation of our care.</li>
              <li><strong>Inclusivity:</strong> We welcome individuals of all backgrounds, cultures, gender identities, and orientations.</li>
              <li><strong>Empowerment:</strong> We believe you are the expert of your own life—we’re here to support your journey.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-3">Why Choose MindTherapyCounselling?</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>A wide range of therapeutic approaches to meet your unique needs</li>
              <li>Flexible online appointments that fit your schedule</li>
              <li>Carefully selected, experienced, and compassionate therapists</li>
              <li>A secure and confidential environment</li>
              <li>Commitment to long-term mental wellness, not just symptom relief</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
